'use client';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Moon, Sun } from '@phosphor-icons/react';
import { useTheme } from 'next-themes';
import * as React from 'react';

export function ModeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          suppressHydrationWarning
          className="group rounded-xl shadow-none"
          variant="outline"
          size="icon"
        >
          {theme === 'light' ? (
            <Moon
              weight="fill"
              size={32}
              className="text-primary group-hover:motion-preset-shake transition-all"
            />
          ) : (
            <Sun
              weight="fill"
              size={32}
              className="text-primary group-hover:motion-rotate-in-[0.5turn] transition-all"
            />
          )}
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="border-border/50">
        <DropdownMenuItem onClick={() => setTheme('light')}>
          Light
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')}>
          Dark
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('system')}>
          System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
